// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"29":"87abb6d7","77":"2e0756bb","493":"95a69dc0","538":"a09d3f9f","652":"b555abea","693":"94d745da","763":"173302a0","847":"5185cd64","892":"df411410","970":"ba76bf32"}[chunkId] + ".chunk.js";
};